import {
  runExport,
  formatExportDate,
} from '../../retail-pos/utils/exportRetailData';
import {
  filterMovimientos,
  filterProductosById,
  calcularStockHasta,
  obtenerPrecioPromedioHasta,
  getMovementLabel,
} from './inventarioFilters';

export function buildKardexRecords(movimientos, productos, filters) {
  const productMap = new Map((productos || []).map((p) => [p.id, p.nombre]));
  const filtered = filterMovimientos(movimientos, filters);

  return [...filtered]
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    .map((m) => {
      const cantidad = parseFloat(m.cantidad) || 0;
      const precio = parseFloat(m.precio) || 0;
      return {
        fecha: m.fecha,
        transaccion: (m.transactionID || m.id || '').substring(0, 8).toUpperCase(),
        producto: productMap.get(m.productoId) || m.productoId,
        tipo: getMovementLabel(m),
        subTipo: m.subTipo || '',
        cantidad,
        precioUnit: precio,
        total: cantidad * precio,
        metodoPago: m.metodoPago || 'EFECTIVO',
        anulado: m.anulado ? 'Sí' : 'No',
      };
    });
}

export function buildStockRecords(movimientos, productos, productId = 'TODOS', metodo = 'PROMEDIO') {
  const list = filterProductosById(productos, productId);

  return list.map((p) => {
    const stock = calcularStockHasta(movimientos, p.id);
    const avg = obtenerPrecioPromedioHasta(movimientos, p.id, undefined, metodo);
    const valor = stock * avg;

    return {
      producto: p.nombre,
      stock,
      valor,
      valorUnit: stock > 0 ? valor / stock : avg,
    };
  });
}

const KARDEX_VALUE_GETTERS = {
  fecha: (r) => formatExportDate(r.fecha),
};

export function prepareInventarioExport({
  dataset,
  orderedSelectedKeys,
  columns,
  records,
  filenameBase,
  format,
  dateFrom,
  dateTo,
}) {
  const colMap = new Map(columns.map((c) => [c.key, c]));
  const activeCols = orderedSelectedKeys.map((k) => colMap.get(k)).filter(Boolean);
  const headers = activeCols.map((c) => c.label);
  const rows = records.map((record) =>
    activeCols.map((colDef) => {
      if (KARDEX_VALUE_GETTERS[colDef.key]) return KARDEX_VALUE_GETTERS[colDef.key](record);
      const raw = record[colDef.key];
      if (typeof raw === 'number') return raw;
      if (raw == null) return '';
      return raw;
    })
  );

  runExport({ format, headers, rows, filenameBase, dateFrom, dateTo });
  return rows.length;
}
